
import { MailSettings } from "@/models/mail-settings";
import { MailSettingsService } from "@/services/mail-settings-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMailSettings from "../../../components/settings-default/MailsSettings.vue";

export default Vue.extend({
	data() {
		return {
			mailSettings: null as null | MailSettings,
			unsavedChanges: false
		};
	},
	computed: {
		path():IBreadCrumb[]{
			let label = "";
			if (this.mailSettings){
				label= this.mailSettings.Label;
			}
			return [
				{
					to: "/settings",
					value: this.$ct("general")
				},
				{
					to: "/settings/mails",
					value: this.$ct("mails")
				},
				{
					value: label
				}
			] as IBreadCrumb[];
		}
	},
	watch: {
		maiLSettings: {
			deep: true,
			handler(){
				this.unsavedChanges = true;
			}
		}
	},
	methods: {
		onSettingsSaved(settings:MailSettings){
			this.mailSettings=settings;
			this.unsavedChanges = false;
		}
	},
	async mounted(){
		let id = parseInt(this.$route.params["id"]);
		this.mailSettings = await MailSettingsService.getSettingsById(id);
	},
	components: {
		AppMailSettings,
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
